module.exports = __webpack_public_path__ + "static/media/ban-img1.75150537.png";